import React from "react";
import { useTranslation } from "react-i18next";
import { StepComponentProps } from "../../components/MultiStepGradeModal";
import { ProjectBasedLearningCreateRequestDto } from "@packages/api/madlenAPI.schemas";

export const ExpectedProductTypesStep: React.FC<
  StepComponentProps<ProjectBasedLearningCreateRequestDto>
> = ({ data, onDataChange, themeColor }) => {
  const { t } = useTranslation();

  const handleExpectedProductTypesChange = (value: string) => {
    onDataChange({ expectedProductTypes: value });
  };

  return (
    <div className="space-y-8">
      <div className="text-center mb-6">
        <h2
          className={`text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-${themeColor}-600 to-${themeColor}-800 dark:from-${themeColor}-400 dark:to-${themeColor}-600`}
        >
          {t("projectBasedLearning.steps.productTypes.title")}
        </h2>
        <p className="text-gray-600 dark:text-gray-400 mt-2">
          {t("projectBasedLearning.steps.productTypes.description")}
        </p>
      </div>

      <div>
        <h3
          className={`text-lg font-medium text-${themeColor}-700 dark:text-${themeColor}-300 mb-4`}
        >
          {t("projectBasedLearning.form.expectedProductTypes")}
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
          {t("projectBasedLearning.form.expectedProductTypesDesc")}
        </p>

        <div className="space-y-4">
          <textarea
            value={data.expectedProductTypes || ""}
            onChange={(e) => handleExpectedProductTypesChange(e.target.value)}
            className={`w-full rounded-xl border-2 border-gray-200 dark:border-gray-700 p-4 text-base focus:ring-2 focus:ring-${themeColor}-500 focus:border-transparent dark:bg-gray-700/50 transition-all duration-200 min-h-[150px]`}
            placeholder={t(
              "projectBasedLearning.form.expectedProductTypesPlaceholder",
            )}
          />
        </div>

        {/* Suggestions */}
        <div className="mt-6 p-4 bg-gray-50 dark:bg-gray-800/50 rounded-xl">
          <h4 className="font-medium text-gray-900 dark:text-gray-100 mb-3">
            {t("projectBasedLearning.form.productTypesSuggestions")}:
          </h4>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-2 text-sm">
            <div className="flex items-center gap-2">
              <span>📊</span>
              <span>{t("projectBasedLearning.productTypes.presentation")}</span>
            </div>
            <div className="flex items-center gap-2">
              <span>📝</span>
              <span>{t("projectBasedLearning.productTypes.report")}</span>
            </div>
            <div className="flex items-center gap-2">
              <span>🎨</span>
              <span>{t("projectBasedLearning.productTypes.prototype")}</span>
            </div>
            <div className="flex items-center gap-2">
              <span>🎬</span>
              <span>{t("projectBasedLearning.productTypes.video")}</span>
            </div>
            <div className="flex items-center gap-2">
              <span>🌐</span>
              <span>{t("projectBasedLearning.productTypes.website")}</span>
            </div>
            <div className="flex items-center gap-2">
              <span>📱</span>
              <span>{t("projectBasedLearning.productTypes.app")}</span>
            </div>
            <div className="flex items-center gap-2">
              <span>🏗️</span>
              <span>{t("projectBasedLearning.productTypes.model")}</span>
            </div>
            <div className="flex items-center gap-2">
              <span>📖</span>
              <span>{t("projectBasedLearning.productTypes.portfolio")}</span>
            </div>
            <div className="flex items-center gap-2">
              <span>🎭</span>
              <span>{t("projectBasedLearning.productTypes.performance")}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
